import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Left - Image side */}
            <div className="relative min-h-[400px] md:min-h-[500px] rounded-3xl lg:rounded-r-none overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=crowded%20nightlife%20street%20scene%2C%20neon%20signs%20and%20billboards%2C%20energetic%20urban%20atmosphere%2C%20warm%20red%20and%20orange%20lighting%2C%20cinematic%20street%20photography%2C%20nightlife%20culture%20vibes%2C%20slightly%20blurred%20motion%20effect&width=960&height=700&seq=cta-left&orientation=landscape"
                alt="加入吃瓜圈"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent" />
              <div className="absolute top-6 left-6">
                <span className="text-white/80 text-xs font-medium tracking-wider uppercase">
                  吃瓜圈社区
                </span>
              </div>
              <div className="absolute bottom-6 left-6 right-6">
                <h3 className="font-heading font-black text-white text-3xl md:text-4xl lg:text-5xl leading-tight">
                  加入53
                  <br />
                  吃瓜大军
                </h3>
              </div>
            </div>

            {/* Right - Content side */}
            <div className="flex flex-col justify-center p-8 md:p-12 lg:p-16 bg-background-50 lg:bg-background-100 rounded-3xl lg:rounded-l-none">
              <h3 className="font-heading font-black text-foreground-950 text-2xl md:text-3xl lg:text-4xl text-center mb-4">
                不错过每一个
                <br />
                <span className="text-primary-500">劲爆爆料</span>
              </h3>
              <p className="text-foreground-600 text-base leading-relaxed text-center mb-8 max-w-md mx-auto">
                关注53吃瓜网，第一时间获取娱乐圈最新动态。这里有最真实的爆料、最深入的追踪、最及时的更新。
              </p>
              <div className="text-center">
                <Link
                  to="/about"
                  className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-foreground-900 text-white font-medium hover:bg-primary-600 transition-colors"
                >
                  立即加入
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}